/** True when address or lat/lng coordinates are dirty in an RHF form. */
export function isLocationDirty(dirtyFields: {
  address?: boolean;
  coordinates?: boolean | { lat?: boolean; lng?: boolean };
}): boolean {
  const coordinatesDirty =
    dirtyFields.coordinates === true ||
    (typeof dirtyFields.coordinates === "object" &&
      Boolean(dirtyFields.coordinates?.lat || dirtyFields.coordinates?.lng));
  return !!(dirtyFields.address || coordinatesDirty);
}
